import { call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/specialties';
import * as types from './types';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';

function* createSpecialtyRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.addSpecialty, payload);
    onSucess()
    yield showSuccessMsg('addedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* updateSpecialtyRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.editSpecialty, payload);
    onSucess()
    yield showSuccessMsg('editedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* deleteSpecialtyRequestSaga({ payload, onSucess }) {
  try {
    yield call(apis.deleteSpecialty, payload);
    onSucess()
    yield showSuccessMsg('deletedSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

export default function* SpecialtiesSagas() {
  yield takeEvery(types.CREATE_SPECIALTY_REQUEST, createSpecialtyRequestSaga);
  yield takeEvery(types.UPDATE_SPECIALTY_REQUEST, updateSpecialtyRequestSaga);
  yield takeEvery(types.DELETE_SPECIALTY_REQUEST, deleteSpecialtyRequestSaga);
}